import { ref } from 'vue';
import router from '@/common/router';
import { useBaseMenuStore } from '@/common/stores/base-menu';
import { useDashboardFavorite } from '@/common/components/organisms/baseMenu/baseMenu.uses';
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';
import { useEllipsisTooltip } from '@/common/components/molecules/simpleTextTooltip/ellipsisTooltip.uses';
import { MenuInfo } from '../types';

export interface Props {
  dashboardInfo: MenuInfo;
  selected?: boolean;
}

export const setup = (props: Props) => {
  const favoriteRef = ref<InstanceType<typeof BaseButton> | null>(null);

  const { selectSubPanelMenu } = useBaseMenuStore();
  const { isFavorited, isAnalysisFavorited, updateFavorite } = useDashboardFavorite(
    props.dashboardInfo,
  );

  const { tooltipMouseEvent, onMouseEventOnText } = useEllipsisTooltip();

  const onClickElement = async (e: MouseEvent) => {
    const favoriteEl = favoriteRef.value?.innerButtonRef;
    const targetEl = e.target as HTMLElement;

    if (!favoriteEl) {
      return;
    }
    if (favoriteEl.contains(targetEl)) {
      updateFavorite();
      return;
    }
    if (!props.dashboardInfo.path) {
      return;
    }
    selectSubPanelMenu(props.dashboardInfo.value);
    router.push(props.dashboardInfo.path);
  };

  return {
    isFavorited,
    isAnalysisFavorited,
    favoriteRef,
    tooltipMouseEvent,
    onMouseEventOnText,
    onClickElement,
  };
};
